import { render, staticRenderFns } from "./reborrowCount.vue?vue&type=template&id=135ba41b&scoped=true&"
import script from "./reborrowCount.vue?vue&type=script&lang=js&"
export * from "./reborrowCount.vue?vue&type=script&lang=js&"
import style0 from "./reborrowCount.vue?vue&type=style&index=0&id=135ba41b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ba41b",
  null
  
)

export default component.exports